export enum FeatureFlags {
  ADMIN_TEAMS_FACILITIES_ADD_FACILITY = 'admin_teams_facilities_add_facility',
  CHART_FIXED_INR_FORMAT = 'chart_fixed_inr_format',
  DRAGONFLY_ASYNC_MODE = 'dragonfly_async_mode',
  ENG_3403_FIX_INSERT_INTO_ENTITY_OUTBOUND_REVIEW_LOG = 'eng_3403_fix_insert_into_entity_outbound_review_log',
  ENG_3590_REMOVE_DUPLICATE_REVIEWS_ON_REPORTING_PAGE = 'eng_3590_remove_duplicate_reviews_on_reporting_page',
  EVENT_REVIEW_AUTOSAVE = 'event_review_autosave',
  P2P_GEN_AI = 'p2p_gen_ai',
  PA_MERLOT_CONNECTION = 'pa_merlot_connection',
  PA_MERLOT_PARITY = 'pa_merlot_parity',
  PA_ROADRUNNER_PARITY = 'pa_roadrunner_parity',
  PARR_INTEROPERABILITY = 'parr_interoperability',
  QUEUE_PA_STATUS_INDICATOR_P2P = 'queue_pa_status_indicator_p2p',
  REVIEW_AUTOSAVE = 'review_autosave',
  REVIEWERS_USES_CACHE = 'reviewers_uses_cache',
  REVIEW_MULTIPLE_COMMENTS = 'review_multiple_comments',
  REVIEW_PREVENT_MULTIPLE_OPEN = 'review_prevent_multiple_open',
  REVIEWS = 'reviews',
  REVIEWS_VIEW_CHART_BTN = 'reviews_view_chart_btn',
  SYSTEM_BYPASS_SCRUBBED = 'system_bypass_scrubbed',
  TEAMS_CREATE_NEW_USER_TYPE_AND_NEW_USER = 'teams_create_new_user_type_and_new_user',
  PWQ_AG_GRID = 'pwq_ag_grid',
  ENABLE_LOS_DECIMAL = 'enable_los_decimal',
}

export const EMPTY_STRING = '';
